const theme = {
  highlightedTextsInDefaultColor: false,
  colors: {
    mono: {
      white: '#FFF',
      greyLight: '#F6F6F6',
      grey: '#DADADA',
      greyDark: '#D5D8DD',
      greyDarker: '#8F99A3',
      black: '#434647',
      blackDark: '#282828',
    },
    primary: {
      default: '#0D3577',
      dark: '#0D3577D9',
      light: '#0D357733',
      info: '#2884bc',
      fontColor: '#434647'
    },
    secondary: {
      default: '#EF7743',
      dark: '#EF7743D9',
      light: '#EF774333',
    },
    yellow: {
      default: '#FDC20B',
      light: '#FDC20B33',
    },
    red: {
      default: '#E52725',
      light: '#E5272533',
    },
    green: {
      default: '#79A942',
      light: '#79A94233',
    },
    blue: {
      default: '#0D3577',
      dark: '#0D3577D9',
      light: '#0D357733',
      info: '#2884bc',
    },
    grey: {
      0: '#FFFFFF',
      100: '#F9FAFB',
      200: '#F4F6F8',
      300: '#DFE3E8',
      400: '#C4CDD5',
      500: '#919EAB',
      600: '#637381',
      700: '#454F5B',
      800: '#212B36',
      900: '#161C24',
    },
  },
  shadows: {
    primary: '0px 70px 80px rgba(255, 99, 0, 0.12), 0px 30px 30px rgba(208, 81, 0, 0.08), 0px 20px 30px rgba(157, 61, 0, 0.2), 0px 0px 20px rgba(71, 69, 52, 0.05), 0px 0px 20px rgba(71, 69, 52, 0.05), 0px 0px 40px rgba(71, 69, 52, 0.05)',
    dark: '0px 48px 70px rgba(0, 0, 0, 0.15), 0px 15px 30px rgba(0, 0, 0, 0.08), 0px 15px 15px rgba(0, 0, 0, 0.05), 0px 0px 15px rgba(0, 0, 0, 0.05), 0px 0px 5px rgba(0, 0, 0, 0.03), 0px 0px 2px rgba(0, 0, 0, 0.0196802)',
    smooth: '0px 10px 30px rgba(0, 0, 0, 0.08), 0px 9px 9px rgba(0, 0, 0, 0.04), 0px 5px 5px rgba(0, 0, 0, 0.03), 0px 2px 2px rgba(0, 0, 0, 0.0196802)',
    card: '0px 3px 15px #EAECF1',
  },
  screens: {
    '3xl': '(max-width: 1750px)',
    '2xl': '(max-width: 1536px)',
    xl: '(max-width: 1399.98px)',
    lg: '(max-width: 1199.98px)',
    md: '(max-width: 991.98px)',
    sm: '(max-width: 767.98px)',
    xs: '(max-width: 575.98px)',
  },
  fontSize: {
    xs: '1rem',
    sm: '1.4rem',
    md: '1.8rem',
    lg: '2rem',
  }
}

export default theme
